import { Box, Button, ButtonGroup, Center, Container, Flex, FormControl, FormLabel, HStack, Heading, Stack, Switch, Text } from '@chakra-ui/react';
import IconPencil from 'assets/icons/icon-pencil.svg?react';
import IconSendPlane from 'assets/icons/icon-send-plane.svg?react';
import ButtonEmailPreview from 'components/ButtonEmailPreview';
import BoxDivider from 'components/ui/BoxDivider';
import ButtonBack from 'components/ui/ButtonBack';
import FixedBar from 'components/ui/FixedBar';
import InfoList from 'components/ui/InfoList';
import { useMessages } from 'hooks/useMessages';
import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PageContent from '../../../components/PageContent';
import { LinkContentPreview } from '../config';
import { useSendContent } from '../hooks/useSendContent';
import { useSendTestEmail } from '../hooks/useSendTestEmail';

export default function FormCheckData({ content }: any) {
  const navigate = useNavigate();
  const { id } = useParams();
  const { onError, onSuccess } = useMessages({ success: 'E-mail enviado com sucesso!'});
  const [includesNewsletterLists, setIncludesNewsletterLists] = useState<boolean>(content.includesNewsletterLists);

  const { onSendTestEmail, isPending } = useSendTestEmail({ 
    contentId: id,
    onError, 
    onSuccess
  });

  const { onSendContent, isPending: isPendingSendContent } = useSendContent({ 
    contentId: id,
    onSuccess: () => navigate('/disparos-de-report')
  });

  return (
    <>
      <Box 
        w="full"
        pos="relative"
      >
        <BoxDivider />

        <Container
          variant="internal"
          flexDirection="column" 
        >
          <Flex 
            flex={1} 
            justifyContent="space-between"
          >
            <Heading as="h1" size="h1">
              Conferir dados
              <span>Veja a prévia do e-mail e valide os dados com atenção</span>
            </Heading>

            <Button
              leftIcon={<IconPencil />}
              as={Link}
              to={`/disparos-de-report/editar/${id}/conteudo`}
            >
              Voltar para edição
            </Button>
          </Flex>
        </Container>
      </Box>

      <Container
        variant="internal"
        flexDirection="column" 
        mb="80px"
      >
        <InfoList>
        { !!content.category && (
          <Box>
            <Text as="span">
              <small>Poder</small>
              {content.category.name}
            </Text>
          </Box>
        )}
        { !!content.subcategory && (
          <Box>
            <Text as="span">
              <small>Órgão</small>
              {content.subcategory.name}
            </Text>
          </Box>
        )}
        { !!content.theme && (
          <Box>
            <Text as="span">
              <small>Tema</small>
              {content.theme.name}
            </Text>
          </Box>
        )}
        { !!content.legislativeProposal && (
          <Box>
            <Text as="span">
              <small>Proposição Legislativa</small>
              {content.legislativeProposal.name}
            </Text>
          </Box>
        )}
        {!!content.authors && content.authors.length > 0 && (
          <Box>
            <Text as="span">
              <small>Autor</small>
              {content.authors.map(row => row.name).join(', ')}
            </Text>
          </Box>
        )}
        {!!content.rapporteurs && content.rapporteurs.length > 0 && (
          <Box>
            <Text as="span">
              <small>Relator</small>
              {content.rapporteurs.map(row => row.name).join(', ')}
            </Text>
          </Box>
        )}
        </InfoList>

        <Box 
          bgColor="rgba(226, 228, 233, 0.50)"
          mt="65px"
        >
          <Stack
            bgColor="#20232D"
            padding="28px 23px"
            borderTopRadius="15px"
            color="white"
            direction="row"
            justifyContent="space-between"
          >
            <Box>
              <Text opacity={0.8}>{`De: Patri <patri@patri.com.br>`}</Text>
              <Text fontWeight="semibold">Para: {content.lists.map(row => `${row.company.name} - ${row.name}`).join(', ')}</Text>
            </Box>

            <ButtonEmailPreview url={LinkContentPreview(content)} />
          </Stack>
          
          <Center pb="30px">
            <PageContent url={LinkContentPreview(content)} />
          </Center>
        </Box>
      </Container>

      <FixedBar>
        <ButtonBack 
          as={Link}
          to={`/disparos-de-report/editar/${id}/listas`}
        />
        
        <HStack spacing="50px">
          <FormControl display="flex" alignItems="center" gap="10px">
            <FormLabel htmlFor="includesNewsletterLists" mb="0">
              Forçar o disparo incluindo listas de newsletters 
            </FormLabel>
            <Switch 
              id="includesNewsletterLists" 
              isChecked={includesNewsletterLists}
              onChange={(e) => setIncludesNewsletterLists(e.target.checked)}
            />
          </FormControl>
          
          <ButtonGroup>
            <Button
              bgColor="#F6F8FA"
              border="none"
              color="#525866"
              fontWeight="semibold"
              rightIcon={<IconSendPlane />}
              size="sm"
              isLoading={isPending}
              onClick={() => onSendTestEmail()}
            >
              Enviar e-mail de teste
            </Button>

            <Button
              variant="primary"
              rightIcon={<IconSendPlane />}
              onClick={() => onSendContent({ includesNewsletterLists })}
              isLoading={isPendingSendContent}
            >
              Enviar
            </Button>
          </ButtonGroup>
        </HStack>
      </FixedBar>

    </>
  )
}
